module.exports = __webpack_public_path__ + "img/online.1a61ce6b.svg";